import styled from 'styled-components'
import { DropdownButton } from '@chegg-wt/core/theme/sunkist/buttons'

export const Container = styled.div`
  position: relative;
  align-self: flex-start;
`

export const MenuTrigger = styled.button`
  flex-shrink: 0;
  height: 30px;
  width: 30px;
  border: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor14};
  border-radius: 6px;
  padding: 0;
  background-color: inherit;
  svg {
    margin: 2px 0;
  }
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor21};
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.05);
  position: absolute;
  right: 0;
  z-index: 1;
`

interface OptionProps {
  red?: boolean
}

export const Option = styled.button<OptionProps>`
  ${DropdownButton};
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.red && props.theme.Colors.forFonts.fColor09};
  height: 50px;
  padding: 0 25px;
  text-decoration: none;
`
